import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { action } from "mobx";

class FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;
        super(rootStore, {
            name: 'facility-order-patient-us-intake-add-insurance-info-modal',
            Form: FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalForm,
            id: facilityOrderPatient.id,
            actions: () => {
                return {
                    get: async() =>{
                        return facilityOrderPatient;
                    },
                    update: async() =>{
                        await this.facilityOrderPatientService.update(this.facilityOrderPatient);
                    }
                }
            },
            FormClass: FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.changeInsuranceInfo = this.modalParams.data.changeInsuranceInfo;
        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        this.facilityOrderPatient = facilityOrderPatient;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            this.facilityOrderPatient.insuranceInfo = this.form.$("insuranceInfo").value;
            // Await the save so the backend has recomputed the "Non-Billable Insurance" eligibility status note
            // before the callback reloads the patient to display it.
            await this.actions.update();
            if (this.changeInsuranceInfo) {
                await this.changeInsuranceInfo(this.facilityOrderPatient.insuranceInfo);
            }
            await this.modalParams.close();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.TEMPLATE_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalStore;
